import { OrgSettings } from "../types/orgSettings"

export const ALERTS = {
  "lock.no_tracking": {
    label: "Device not reporting",
    description: () => "Over 24 hours since periodic device update",
  },
  "lock.bat.low": {
    label: "Low battery",
    description: (batteryLevel?: number) => `Device was at ${batteryLevel}% charge`,
  },
  "bicycle.left_unlocked": {
    label: "Bicycle left unlocked",
    description: () => "Bicycle was left unlocked by last renter",
  },
  "lock.shutdown": {
    label: "Device shutdown",
    description: () => "Device has shut down",
  },
  "bicycle.too_long_idle": {
    label: "No recent rides",
    description: (idleBicycleDuration?: OrgSettings["idle_bicycle_duration"]) =>
      idleBicycleDuration ? `Idle for more than ${idleBicycleDuration.charAt(0)} days` : "Bicycle is idle",
  },
  "bicycle.ride_outside": {
    label: "Outside service area",
    description: () => "Cycled outside of the service area",
  },
  "bicycle.return_outside": {
    label: "Outside dropzone",
    description: () => "Bicycle returned outside of dropzone",
  },
  "bicycle.lost_reported": {
    label: "Lost bicycle reported",
    description: () => "Lost bicycle has recently updated its location",
  },
  "bicycle.outside_operational_period": {
    label: "Outside operating hours",
    description: () => "Bicycle was cycled outside operating hours",
  },
  "zone.low_threshold": {
    label: "Asset threshold low",
    description: () => "Not enough assets in this zone",
  },
  "zone.high_threshold": {
    label: "Asset threshold high",
    description: () => "Too many assets in this zone",
  },
  "bicycle.moved_while_deployed": {
    label: "Asset moved while deployed",
    description: () => "Asset was moved while it was deployed",
  },
}
